import ReactDOMServer from 'react-dom/server';
import ReactTooltip from 'react-tooltip';
import Fa from '../../../utils/Fa';
import I18n from '../../../config/i18n';
import { AccommodationDetailsListProps } from '../../../routes/reducers/types';

import './PriceTooltip.css';

type PriceTooltipItemProps = Pick<AccommodationDetailsListProps, 'label' | 'value' | 'info'>;

function PriceTooltipItem({ label, value, info }: PriceTooltipItemProps): JSX.Element {
  return (
    <div className="price-tooltip-content-item">
      <span className="price-tooltip-label">{label}:</span>
      {`${value} ${info}`}
    </div>
  );
}

interface PriceTooltipProps {
  extraOptions: PriceTooltipItemProps[] | undefined;
  costs: PriceTooltipItemProps[] | undefined;
  extraCosts: PriceTooltipItemProps[] | undefined;
  isPriced: boolean;
}

export default function PriceTooltip({
  extraOptions,
  costs,
  extraCosts,
  isPriced,
}: PriceTooltipProps): JSX.Element | null {
  if (!isPriced) {
    return null;
  }

  function TooltipContent(): JSX.Element {
    return (
      <div className="price-tooltip-content">
        <h3 className="price-tooltip-headline">{I18n.t('host.additional_costs')}</h3>
        {costs &&
          costs.map((item, i) => (
            <PriceTooltipItem label={item.label} value={item.value} info={item.info} key={i} />
          ))}
        {extraOptions &&
          extraOptions.map((item, i) => (
            <PriceTooltipItem label={item.label} value={item.value} info={item.info} key={i} />
          ))}

        <h3 className="price-tooltip-headline">
          {I18n.t('activerecord.attributes.extra.optional')}
        </h3>
        {extraCosts &&
          extraCosts.map((item, i) => (
            <PriceTooltipItem label={item.label} value={item.value} info={item.info} key={i} />
          ))}
      </div>
    );
  }

  return (
    <div className="price-tooltip">
      <div
        data-tip={ReactDOMServer.renderToString(<TooltipContent />)}
        data-background-color="#009ac6"
        data-html
      >
        {I18n.t('booking.host_cost')}
        <Fa icon="info" className="price-tooltip-icon" />
      </div>
      <ReactTooltip />
    </div>
  );
}
